import Box from '@mui/material/Box';

import { FEATURE_FLAGS } from 'src/global-config';

import ChatWelcome from './ChatWelcome';
import ChatMessageList from './ChatMessageList';
import ChatInputBox from './input/ChatInputBox';
import { useMessageContext } from './hooks/uesMessageContext';
import FileBrowserDialog from './components/FileBrowserDialog';
import { useChatHistoryContext } from './hooks/useChatHistoryContext';

function ChatView() {
  const { history } = useChatHistoryContext();
  const { fileBrowserDialog } = useMessageContext();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
        ...(history.messages.length && {
          alignItems: 'flex-start',
        }),
        paddingLeft: '12px',
      }}
    >
      {history.messages.length === 0 ? <ChatWelcome /> : <ChatMessageList />}
      <ChatInputBox />

      {/* S3 bucket Dialog */}
      {FEATURE_FLAGS.enableS3Integration && (
        <FileBrowserDialog
          title="Import Files from S3"
          open={fileBrowserDialog.value}
          onClose={fileBrowserDialog.setFalse}
        />
      )}
    </Box>
  );
}

export default ChatView;
